module.exports = __webpack_public_path__ + "static/media/student skill average.34080a53.svg";